import { BaseElement, defineElement } from '@webtides/element-js';

class HoverIndicator extends BaseElement {
    constructor() {
        super();

        this._cursorOnElement = false;
        this._cursorIsLeaving = false;
        this._lastTop = 0;
    }

    properties() {
        return {
            selector: 'li',
            active: -1,
            disabled: false,
            mediaQuery: '',
            activeClass: '',
        };
    }

    connected() {
        this.resetCssProperties();

        if (this.mediaQuery !== '') {
            this.disabled = !window.matchMedia(this.mediaQuery).matches;
        }

        try {
            const resizeObserver = new ResizeObserver(() => {
                this.resetCssProperties();
            });
            resizeObserver.observe(this);
        } catch (e) {
            /**
             *  just catch errors to not produce js errors if ResizeOberserver is not supported
             *  is implemented as an edge case error prevention anyways to fix positions when content elements are changing dimensions after connected is called
             *  */
        }
    }

    watch() {
        return {
            active: () => {
                this.resetCssProperties();
            },
            disabled: () => {
                this._hasAlreadyRendered = false;
            },
        };
    }

    events() {
        return {
            [this.selector]: {
                mouseenter: e => {
                    this._cursorIsLeaving = false;
                    this.setCSSPropertiesByTarget(e.currentTarget);
                    this._cursorOnElement = true;
                },
            },
            this: {
                mouseleave: () => {
                    this._cursorIsLeaving = true;
                    this.resetCssProperties();
                    this._cursorOnElement = false;
                },
            },
            window: {
                resize: () => {
                    // return this.matches("screen and (min-width: 1480px)");
                    if (this.mediaQuery !== '') {
                        this.disabled = !window.matchMedia(this.mediaQuery).matches;
                    }

                    this.resetCssProperties();
                },
            },
        };
    }

    setActiveClass() {
        if (this.activeClass) {
            const children = this.querySelectorAll(this.selector);
            children.forEach((child, index) => {
                child.classList.toggle(this.activeClass, index === this.active);
            });
        }
    }

    resetCssProperties() {
        if (this.active !== -1 && this.disabled === false) {
            const active = this.querySelectorAll(this.selector)[this.active];
            this.setCSSPropertiesByTarget(active);
        } else {
            this.setCssProperties(0, 0, this._lastTop);
        }
    }

    setCssProperties(left, width, top) {
        if (this.disabled) {
            this.style.setProperty('--indicator-scale', `0`);
            return;
        }

        const showScaleTransition =
            (this.active === -1 && (!this._cursorOnElement || this._cursorIsLeaving)) || !this._hasAlreadyRendered;

        this.classList.toggle('scale-transition', showScaleTransition);

        this.style.setProperty('--indicator-scale', `${width === 0 ? 0 : 1}`);
        this.style.setProperty('--indicator-top', `${top}px`);

        if (!(showScaleTransition && this._cursorIsLeaving)) {
            this.style.setProperty('--indicator-width', width + 'px');
            this.style.setProperty('--indicator-left', left + 'px');
        }

        this._lastTop = top;
        this._hasAlreadyRendered = true;
        this.setActiveClass();
    }

    setCSSPropertiesByTarget(target) {
        this.setCssProperties(target.offsetLeft, target.offsetWidth, target.offsetTop + target.offsetHeight);
    }
}

defineElement('hover-indicator', HoverIndicator);
